import { chatConstants } from '../constants';
import { chatService } from '../services';
import { showToast } from '../services/toast';

export const chatActions = {
    fetchChatMessages,
    sendChatMessage,
    updateChatMessages,
    hydrateChatMessages,
    resetChatMessages
};

function fetchChatMessages(classId) {
    return dispatch => {
        dispatch(request(classId));

       return chatService.fetchChatMessages(classId)
            .then(
                response => {
                    dispatch(success(response.data, classId));
                    return response.data;
                },
                error => {
                    dispatch(failure(error, classId));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                    return Promise.reject(error);
                }
            );
    };

    function request(requestedClassId) { return { type: chatConstants.FETCH_CHATMESSAGES_REQUEST, classId: requestedClassId } }
    function success(chatmessages, classId) { return { type: chatConstants.FETCH_CHATMESSAGES_SUCCESS, chatmessages, classId } }
    function failure(error, classId) { return { type: chatConstants.FETCH_CHATMESSAGES_FAILURE, error, classId } }
}

function sendChatMessage(msg) {
    return dispatch => {
        dispatch(request());

        return chatService.sendChatMessage(msg)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: chatConstants.SEND_CHATMESSAGE_REQUEST } }
    function success(chatmessages) { return { type: chatConstants.SEND_CHATMESSAGE_SUCCESS, chatmessages } }
    function failure(error) { return { type: chatConstants.SEND_CHATMESSAGE_FAILURE, error } }
}

function updateChatMessages(newMessages) {
    return dispatch => {
        dispatch({ type: chatConstants.UPDATE_CHATMESSAGES, chatmessages: newMessages });
    };
}

function hydrateChatMessages(chatmessages, classId) {
    return {
        type: chatConstants.HYDRATE_CHATMESSAGES,
        chatmessages,
        classId
    };
}

function resetChatMessages() {
    return { type: chatConstants.RESET_CHATMESSAGES };
}
